
import { updateAppConfig } from '#app'
import { defuFn } from '/azp/_work/1/s/majority-com/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "2a283598-ed9c-4e05-a767-8943ef95fc5d"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
